<template>
  <CRow>
    <CCol col="12" xl="6">
      <transition name="slide">
        <CCard>
          <CCardBody>
            <h4>Αρχεία</h4>
            <div v-show="showUpload">
                <!--CIcon :content="$options.plusIcon"/>
                <CIcon :content="$options.fileIcon"/-->
                <CInputFile
                    type="file"
                    v-on:change="handleFileUpload"
                    placeholder="New file"
                />
            </div>
              <CDataTable
                hover
                :items="items"
                :fields="fields"
              >
                <template #name="{item}">
                  <td>
                    <CIcon :content="$options.fileIcon"/>
                    {{ item.name }}
                  </td>
                </template>
                <template #actions="{item}">
                  <td>
                    <CButton color="primary" @click="renameOpenForm(item.id, item.type)">
                        Μετονομασία
                    </CButton>
                  </td>
                  <td>
                    <CButton color="primary" @click="downloadFile(item.id, item.name)">
                        Λήψη
                    </CButton>
                  </td>
                  <td>
                    <CButton color="danger" @click="openDeleteDialog(item.id, item.type, item.name)">
                        Διαγραφή
                    </CButton>
                  </td>
                </template>
              </CDataTable>
          </CCardBody>  
        </CCard>
      </transition>
    </CCol>
    <CCol col="12" xl="6">
      <transition name="slide">
        <CCard v-if="rightCard == 'fileInfo'">
          <CCardBody>
              <CDataTable
                :items="fileInfo"
                :fields="fileInfoHeader"
              >

              </CDataTable>
          </CCardBody>  
        </CCard>
        <CCard v-if="rightCard == 'renameFile'">
          <CCardBody>
            <CInput 
                type="text"
                label="New name"
                placeholder="Folder name"
                v-model="name"
            />
            <CButton color="primary" @click="renameFile()">
                Αποθήκευση
            </CButton>
            <CButton color="primary" @click="rightCard = 'fileInfo'">
                Ακύρωση
            </CButton> 
          </CCardBody>  
        </CCard>
      </transition>
    </CCol>
    <CModal
      :show.sync="deleteFileModal"
      :centered="true"
      title="Delete file"
    >
        Είστε σίγουρος ότι θελετε να διαγράψετε το αρχείο "{{moveObjectName}}"?
      <template #footer>
        <CButton @click="deleteFileModal = false" color="primary">Ακύρωση</CButton>
        <CButton @click="deleteFile" color="danger">Διαγραφή</CButton>
      </template>
    </CModal>
  </CRow>
</template>
<script>
import axios from 'axios'
import { cilPlus, cilFolder, cilFile, cilLevelUp } from '@coreui/icons'
export default {
  plusIcon: cilPlus,
  folderIcon: cilFolder,
  fileIcon: cilFile,
  levelUpIcon: cilLevelUp,
  name: 'ClientMedia',
  data () {
    return {
        rightCard: 'fileInfo',
        elementId: null,
        thisFolder: null,
        name: null,
        medias: [],
        mediaFolders: [],
        parentFolder: 'disable',
        fields: ['name', 'actions'],
        items: [],
        returnFolderId: null,
        fileInfoHeader: ['name', 'data'],
        fileInfo: [],
        selectFolder: null,
        deleteFolderModal: false,
        deleteFileModal: false,
        downloadFileName: '',
        changePort: '',
        client_id: '',
        moveObjectName: '',
        showUpload: true,
    }
  },
  methods: {
    downloadFile(id, name){
        let self = this
        this.downloadFileName = name
        self.elementId = id
        axios({
            method: 'get',
            url: '/api/clients/downloadFile/' + self.client_id + '?id=' + self.elementId + '&token=' + localStorage.getItem("api_token"),
            responseType: 'arraybuffer'
        })
        .then(function(response){
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', self.downloadFileName)
            document.body.appendChild(link)
            link.click()
        })
        .catch(function(error){
            console.log(error)
            self.$router.push({ path: '/login' })
        });


    },
    openDeleteDialog(id, type, name){
        this.moveObjectName = name
        this.elementId = id
        this.deleteFileModal = true
    },
    deleteFile(){
        let self = this
        axios.post( '/api/clients/deleteFile/' + self.client_id + '?id=' + self.elementId + '&token=' + localStorage.getItem("api_token")
        ).then(function(response){
            self.getFoldersAndFiles()
            self.rightCard = 'fileInfo'
            self.deleteFileModal = false
        })
        .catch(function(error){
            console.log(error)
            self.$router.push({ path: '/login' })
        });
    },
    renameOpenForm(id, type){
        this.elementId = id
        let self = this
        
        let file = self.medias.find((t) => t.id == this.elementId);
        self.name = file.name
        self.rightCard = 'renameFile'
    },
    renameFile(){
        let self = this;
        axios.post( '/api/clients/updateFile/'+this.client_id,
        {
            name: this.name,
            id: this.elementId,
            token: localStorage.getItem("api_token"),
        }
        ).then(function(response){
            self.getFoldersAndFiles()
            self.rightCard = 'fileInfo'
        })
        .catch(function(error){
            console.log(error)
            self.$router.push({ path: '/login' })
        });
    },
    handleFileUpload(files, event){
        let self = this;
        let formData = new FormData();
        formData.append('file', files[0]);
        axios.post( '/api/clients/addFile/' + self.client_id + '?token=' + localStorage.getItem("api_token"),
            formData,
            { headers: {
                'Content-Type': 'multipart/form-data'
            }}
        ).then(function(){
            self.getFoldersAndFiles()
        })
        .catch(function(error){
            console.log(error)
            self.$router.push({ path: '/login' })
        });
    },
    buildItems(){
        this.items = [];
        for(var i=0; i<this.medias.length; i++){
            this.items.push({
                type: 'file',
                name: this.medias[i].name,
                id: this.medias[i].id,
                url: this.medias[i].url,
                mime: this.medias[i].mime_type
            })
        }
    },
    getFoldersAndFiles(){
        let self = this;
        axios.get('/api/clients/getFile/' + self.client_id + '?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
            if ( response.data.id ) {
                self.medias = [response.data];
                self.showUpload = false;
            } else {
                self.medias = [];
                self.showUpload = true;
            }
            self.buildItems();
            self.rightCard = 'fileInfo';
        }).catch(function (error) {
            console.log(error.response.status);
            self.$router.push({ path: '/login' });
        });
    }
  },
  mounted () {
    let self = this;
    self.client_id = self.$route.params.id;
    self.getFoldersAndFiles();
  }
}
</script>
